import { useNavigate, createFileRoute } from '@tanstack/react-router';
import FigmaPluginIntegration from '@/components/settings/FigmaPluginIntegration';
import { FEATURE_FLAGS, useFeatureFlag } from '@/hooks/useFeatureFlag';
import FigmaWhiteGloveConnection from '@/components/settings/FigmaWhiteGloveConnection';

import { Box, Button } from '@mui/material';

import { paths } from 'src/routes/paths';

import { Iconify } from 'src/components/iconify';

export const Route = createFileRoute(
  '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/figma'
)({
  component: FigmaIntegrationPage,
});

function FigmaIntegrationPage() {
  const navigate = useNavigate();
  const { orgId, clientId } = Route.useParams();
  // The connection exists only for White Glove review, which waits on Figma
  // approving the comment scopes.
  const reviewEnabled = useFeatureFlag(FEATURE_FLAGS.FIGMA_WHITE_GLOVE_REVIEW);

  return (
    <Box>
      <Button
        size="small"
        startIcon={<Iconify icon="eva:arrow-back-fill" width={16} />}
        onClick={() =>
          navigate({
            to: paths.dashboard.orgSettings(orgId).client.clientIntegrations(clientId),
          })
        }
        sx={{ mb: 2, textTransform: 'none' }}
      >
        Back to Integrations
      </Button>
      <FigmaPluginIntegration />
      {reviewEnabled && <FigmaWhiteGloveConnection orgId={orgId} clientId={clientId} />}
    </Box>
  );
}
